import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

const StyledSidebarInputField = styled.div`
  font-style: normal;
  font-weight: 400;
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
`

const StyledInputField = styled.input`
  display: flex;
  flex: 1;
  position: relative;
  height: 30px !important;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  border-radius: 3px;
  padding: 0 25px 0 8px !important;
  outline: none;

  border: 1px solid ${colors.secondary70};

  &:focus {
    border: 1px solid ${colors.primary40};
  }
`

const StyledSubmitButton = styled(IconLink)`
  margin-left: 8px;
`

const StyledClearButton = styled(IconLink)`
  position: absolute;
  right: 0;
  margin-right: 32px;
`

const SidebarInputField = ({
  value, placeholder, fieldName, disabled, isNumber, onChange,
}) => {
  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const onClear = () => {
    setInputValue('')
  }

  const handleObjectUpdate = () => {
    onChange(inputValue, fieldName)
  }

  const updateInputValue = (event) => {
    setInputValue(event.target.value)
  }

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleObjectUpdate()
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      setInputValue(value)
    }
  }

  return (
    <StyledSidebarInputField>
      <StyledInputField
        type={isNumber ? 'number' : 'text'}
        min={isNumber ? '1' : undefined}
        disabled={disabled}
        placeholder={placeholder}
        value={inputValue}
        onChange={updateInputValue}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
      />
      {(inputValue || isNumber) && (
        <StyledClearButton
          disabled={disabled}
          iconName='icon-clear-search'
          onClick={onClear}
        />
      )}
      <StyledSubmitButton
        disabled={disabled}
        onClick={handleObjectUpdate}
        iconName='icon-confirm'
      />
    </StyledSidebarInputField>
  )
}

SidebarInputField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  placeholder: PropTypes.string,
  fieldName: PropTypes.string,
  disabled: PropTypes.bool,
  isNumber: PropTypes.bool,
  onChange: PropTypes.func,
}

export default SidebarInputField
